module.exports = __webpack_public_path__ + "img/tele2.25eb07fe.png";